import React from 'react';
import ProgressHeader from './ProgressHeader';
import ContinueButton from './common/ContinueButton';

/**
 * Step 4 (Flow Élève): Contact parent (optionnel)
 */
export default function Step4ParentContact({
  formData,
  currentStepNumber,
  currentStepMessage,
  totalSteps,
  canContinue,
  validationMessage,
  onUpdateStudentInfo,
  onSetParentContact,
  onComplete,
  onBack,
}) {
  return (
    <div className="min-h-[100dvh] bg-[#F0FDFA] flex flex-col">
      <ProgressHeader
        currentStep={currentStepNumber}
        totalSteps={totalSteps}
        message={currentStepMessage}
        showBack={true}
        onBack={onBack}
      />

      <div className="flex-1 px-4 pb-4 overflow-y-auto">
        {/* Icône et Titre */}
        <div className="text-center py-6">
          <div className="w-16 h-16 rounded-full bg-[#94A3B8] flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Encore une chose, {formData.studentName}
          </h1>
          <p className="text-gray-500">
            Veux-tu que GeniMi contacte ton parent pour t'accompagner ?
          </p>
        </div>

        {/* Options */}
        <div className="space-y-4 mb-6">
          {/* Option: Oui, contactez mon parent */}
          <div
            onClick={() => onSetParentContact(true)}
            className={`
              bg-white rounded-2xl p-5 cursor-pointer transition-all
              ${formData.wantsParentContact === true
                ? 'border-[#10B981] border-3 bg-[#F0FDF4]'
                : 'border-gray-200 border-2 hover:border-gray-300'
              }
            `}
          >
            <div className="flex flex-col items-center text-center">
              <span className="text-4xl mb-3">👍🏾</span>
              <p className="font-bold text-gray-800 text-lg">Oui, contactez mon parent</p>
              <p className="text-gray-500 text-sm mt-1">
                Ton parent recevra un SMS pour t'aider à progresser
              </p>
            </div>
          </div>

          {/* Option: Non, je veux travailler seul */}
          <div
            onClick={() => onSetParentContact(false)}
            className={`
              bg-white rounded-2xl p-5 cursor-pointer transition-all
              ${formData.wantsParentContact === false
                ? 'border-[#10B981] border-3 bg-[#F0FDF4]'
                : 'border-gray-200 border-2 hover:border-gray-300'
              }
            `}
          >
            <div className="flex flex-col items-center text-center">
              <span className="text-4xl mb-3">💪🏾</span>
              <p className="font-bold text-gray-800 text-lg">Non, je veux travailler seul</p>
              <p className="text-gray-500 text-sm mt-1">
                Tu peux commencer tout de suite
              </p>
            </div>
          </div>
        </div>

        {/* Champ numéro de téléphone (si "oui" sélectionné) */}
        {formData.wantsParentContact === true && (
          <div className="bg-white rounded-2xl p-5 shadow-lg border-2 border-[#10B981]">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl">📞</span>
              <span className="font-bold text-gray-800">Numéro de téléphone de ton parent</span>
            </div>
            <div className="flex items-center gap-2 border-2 border-gray-200 rounded-xl p-3 focus-within:border-[#2DD4BF]">
              <span className="text-gray-500 font-medium">+221</span>
              <input
                type="tel"
                value={formData.parentPhone || ''}
                onChange={(e) => onUpdateStudentInfo('parentPhone', e.target.value.replace(/\D/g, ''))}
                placeholder="7X XXX XX XX"
                className="flex-1 focus:outline-none text-gray-700"
                maxLength={9}
              />
            </div>
          </div>
        )}

        {/* Astuce */}
        <div className="mt-6 bg-[#FEF3C7] rounded-xl p-4">
          <p className="text-gray-700 text-sm text-center flex items-center justify-center gap-2">
            <span>💡</span>
            Les élèves accompagnés par leurs parents progressent 2 fois plus vite
          </p>
        </div>
      </div>

      {/* Bouton Continuer */}
      <div className="sticky bottom-0 bg-[#F0FDFA] p-4 border-t border-gray-100">
        {validationMessage && !canContinue && (
          <p className="text-center text-sm text-gray-500 mb-2">{validationMessage}</p>
        )}
        <ContinueButton
          onClick={onComplete}
          disabled={!canContinue}
          label="Terminer"
        />
      </div>
    </div>
  );
}
